const TableIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2668 15.1667H2.7335C1.4535 15.1667 0.833496 14.5133 0.833496 13.18V10.4867C0.833496 9.14667 1.4535 8.5 2.7335 8.5H13.2668C14.5468 8.5 15.1668 9.15333 15.1668 10.4867V13.18C15.1668 14.5133 14.5468 15.1667 13.2668 15.1667ZM2.7335 9.5C2.06016 9.5 1.8335 9.64 1.8335 10.4867V13.18C1.8335 14.0267 2.06016 14.1667 2.7335 14.1667H13.2668C13.9402 14.1667 14.1668 14.0267 14.1668 13.18V10.4867C14.1668 9.64 13.9402 9.5 13.2668 9.5H2.7335Z"
        fill="CurrentColor"
      />
      <path
        d="M13.2668 7.50016H2.7335C1.4535 7.50016 0.833496 6.84683 0.833496 5.5135V2.82016C0.833496 1.48016 1.4535 0.833496 2.7335 0.833496H13.2668C14.5468 0.833496 15.1668 1.48683 15.1668 2.82016V5.5135C15.1668 6.84683 14.5468 7.50016 13.2668 7.50016ZM2.7335 1.8335C2.06016 1.8335 1.8335 1.9735 1.8335 2.82016V5.5135C1.8335 6.36016 2.06016 6.50016 2.7335 6.50016H13.2668C13.9402 6.50016 14.1668 6.36016 14.1668 5.5135V2.82016C14.1668 1.9735 13.9402 1.8335 13.2668 1.8335H2.7335Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export { TableIcon };
export default TableIcon;
